import _ from 'lodash';
import $ from 'jquery';
import * as bootstrap from 'bootstrap';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window._ = _;
window.$ = window.jQuery = $;
window.bootstrap = bootstrap;

[
    bootstrap.Modal,
    bootstrap.Toast,
    bootstrap.Tooltip,
].forEach((plugin) => {
    if (!plugin || !plugin.NAME || !plugin.jQueryInterface) {
        return;
    }

    $.fn[plugin.NAME] = plugin.jQueryInterface;
    $.fn[plugin.NAME].Constructor = plugin;
});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// import axios from 'axios';
// window.axios = axios;

// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import io from 'socket.io-client';
// window.io = io;

// window.Echo = new Echo({
//     broadcaster: 'socket.io',
//     host: 'http://localhost:9090'
// });
